export const fetch_mockup = (mockup_id) => {
	var url = global.config.server_path+'mockup/get_one/';
	return fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({id : mockup_id})})
	.then(resp => (Promise.resolve(resp.json())))
	.catch(err => (Promise.reject(err)))
}

export const create_order = (email, amount, coupon_code) => dispatch => {
	var url = global.config.server_path+'order/add/';
	var data = {email, amount};
	if (coupon_code) {
		data = {...data, coupon_code};
	}
	return fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify(data)})
	.then(resp => (Promise.resolve(resp.json())))
	.catch(err => (Promise.reject(err)))
}

export const confirm_order = (order_id, mockup_id, inputs, payment_details) => dispatch => {
	var url = global.config.server_path+'order/confirm/';
	return fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({order_id, mockup_id, data: JSON.stringify({inputs}), payment_details})})
	.then(resp => (Promise.resolve(resp.json())))
	.catch(err => (Promise.reject(err)))
}


export const getMockupRenderStatus = async (orderId, skuIndex) => {
	try {
		let url = global.config.server_path+'order/mockup/render/status';
		let data = await fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({orderId: orderId, skuIndex: skuIndex})});
		data = await data.json();
		if (data.response_code === 1) {
			return data.data;
		}
		else {
			return Promise.reject("Failed to fetch data");
		}
	} catch (e) {
		console.error(e);
	}
};